import { render, staticRenderFns } from "./DocumentHeader.vue?vue&type=template&id=c84daed8&scoped=true&"
import script from "./DocumentHeader.vue?vue&type=script&lang=js&"
export * from "./DocumentHeader.vue?vue&type=script&lang=js&"
import style0 from "./DocumentHeader.vue?vue&type=style&index=0&id=c84daed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84daed8",
  null
  
)

export default component.exports